import { combineReducers } from "redux"
import reducers from "./app/reducers"

export default combineReducers({
  ...reducers,
})
